import register from '@wcd/preact-custom-element';
import { CtaSticky } from '../../../types/web-components';
import { h } from "preact";
import { useEffect, useState } from 'preact/hooks';

export const component: CtaSticky = ({ children }: any) => {
  const [offset, setOffset] = useState(0);

  const check = () => {
    const firstContainer = document.querySelector(".rdp-cta__container");
    const stickyContainer = document.querySelector(".rdp-cta__container--sticky");
    setOffset(window.scrollY);
    
    if (firstContainer && stickyContainer){
      if(document.documentElement.scrollTop > (1.15*(firstContainer.clientTop + firstContainer.clientHeight) )) {
        stickyContainer.classList.add("rdp-cta__container--stuck");
      }
      else {
        stickyContainer.classList.remove("rdp-cta__container--stuck");
      }
    }
  }

  useEffect(() => {
    window.removeEventListener('scroll', check);
    window.addEventListener('scroll', check, {passive: true});
    return () => window.removeEventListener('scroll', check);
  }, [offset])

  return (
    <div className="rdp-cta__container--sticky">
      <div className="rdp-cta__container">
        {children}
      </div>
    </div>
  );
};
register(component, 'cta-sticky', [], { shadow: false });